import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { noop } from 'lodash';

import './index.scss';

const ButtonIcon = ({
    preventCloseAction,
    handleMouseEnter,
    toggle,
    onClick = noop,
    isOpen,
    className,
    unreadDotClassName,
    content,
    unseenCount,
}) => {
    const unreadClass = classNames('button-icon', className, {
        'is-open': isOpen,
    });

    const handleClick = (event) => {
        onClick({ isOpen: !isOpen });
        toggle(event);
    };

    return (
        <button ref={preventCloseAction} className={unreadClass} onMouseEnter={handleMouseEnter} onClick={handleClick}>
            <>
                {content}
                {unseenCount > 0 && <div className={classNames('unread-icon', unreadDotClassName)} />}
            </>
        </button>
    );
};

ButtonIcon.propTypes = {
    preventCloseAction: propTypes.func,
    handleMouseEnter: propTypes.func,
    toggle: propTypes.func,
    onClick: propTypes.func,
    content: propTypes.object,
    isOpen: propTypes.bool,
    className: propTypes.string,
    unreadDotClassName: propTypes.string,
    unseenCount: propTypes.number.isRequired,
};

export default ButtonIcon;
